// test362
(362 && 0);
